<li
  #dragElement
  role="treeitem"
  [ngClass]="dwNodeClass"
  [class.ant-tree-treenode-switcher-open]="isSwitcherOpen"
  [class.ant-tree-treenode-switcher-close]="isSwitcherClose"
  [class.ant-tree-treenode-checkbox-checked]="dwTreeNode.isChecked"
  [class.ant-tree-treenode-checkbox-indeterminate]="dwTreeNode.isHalfChecked"
  [class.ant-tree-treenode-selected]="dwTreeNode.isSelected"
  [class.ant-tree-treenode-loading]="dwTreeNode.isLoading">
  <ng-container *ngIf="dwShowExpand">
    <span
      [ngClass]="dwNodeSwitcherClass"
      [class.ant-tree-switcher_open]="isSwitcherOpen"
      [class.ant-tree-switcher_close]="isSwitcherClose"
      (click)="_clickExpand($event)">
    </span>
  </ng-container>
  <ng-container *ngIf="dwCheckable">
    <span
      class="ant-tree-checkbox"
      [class.ant-tree-checkbox-checked]="dwTreeNode.isChecked"
      [class.ant-tree-checkbox-indeterminate]="dwTreeNode.isHalfChecked"
      [class.ant-tree-checkbox-disabled]="(dwTreeNode.isDisabled || dwTreeNode.isDisableCheckbox)"
      (click)="_clickCheckBox($event)">
      <span class="ant-tree-checkbox-inner"></span>
    </span>
  </ng-container>
  <ng-container *ngIf="!dwTreeTemplate">
    <span
      title="{{dwTreeNode.title}}"
      [attr.draggable]="canDraggable"
      [attr.aria-grabbed]="canDraggable"
      [ngClass]="dwNodeContentClass"
      [class.ant-tree-node-content-wrapper-open]="isSwitcherOpen"
      [class.ant-tree-node-content-wrapper-close]="isSwitcherClose"
      [class.ant-tree-node-selected]="dwTreeNode.isSelected"
      [class.draggable]="canDraggable">
      <span
        *ngIf="dwTreeNode.origin.icon"
        [class.ant-tree-icon__open]="isSwitcherOpen"
        [class.ant-tree-icon__close]="isSwitcherClose"
        [class.ant-tree-icon_loading]="dwTreeNode.isLoading"
        [ngClass]="dwNodeContentLoadingClass">
        <span
          [ngClass]="dwNodeContentIconClass">
          <i class="anticon" [ngClass]="dwTreeNode.origin.icon"></i>
        </span>
      </span>
      <span class="ant-tree-title">
        <ng-container *ngIf="dwTreeNode.isMatched">
          <span>
            {{highlightKeys[0]}}<span class="font-highlight">{{dwSearchValue}}</span>{{highlightKeys[1]}}
          </span>
        </ng-container>
        <ng-container *ngIf="!dwTreeNode.isMatched">
          {{dwTreeNode.title}}
        </ng-container>
      </span>
    </span>
  </ng-container>
  <ng-template
    [ngTemplateOutlet]="dwTreeTemplate"
    [ngTemplateOutletContext]="{ $implicit: dwTreeNode }">
  </ng-template>

  <ul
    role="group"
    [attr.data-expanded]="dwTreeNode.isExpanded"
    [ngClass]="dwNodeChildrenClass"
    [@nodeState]="dwTreeNode.isExpanded ? 'active' : 'inactive'">
    <dw-tree-node
      *ngFor="let node of dwTreeNode.getChildren()"
      [dwTreeNode]="node"
      [dwShowLine]="dwShowLine"
      [dwDraggable]="dwDraggable"
      [dwCheckable]="dwCheckable"
      [dwShowExpand]="dwShowExpand"
      [dwAsyncData]="dwAsyncData"
      [dwMultiple]="dwMultiple"
      [dwExpandAll]="dwExpandAll"
      [dwDefaultExpandAll]="dwDefaultExpandAll"
      [dwSearchValue]="dwSearchValue"
      [dwBeforeDrop]="dwBeforeDrop"
      [dwCheckStrictly]="dwCheckStrictly"
      [dwTreeTemplate]="dwTreeTemplate"
      (clickNode)="clickNode.emit($event)"
      (dblClick)="dblClick.emit($event)"
      (contextMenu)="contextMenu.emit($event)"
      (clickExpand)="clickExpand.emit($event)"
      (clickCheckBox)="clickCheckBox.emit($event)"
      (dwDragStart)="dwDragStart.emit($event)"
      (dwDragEnter)="dwDragEnter.emit($event)"
      (dwDragOver)="dwDragOver.emit($event)"
      (dwDragLeave)="dwDragLeave.emit($event)"
      (dwDrop)="dwDrop.emit($event)"
      (dwDragEnd)="dwDragEnd.emit($event)">
    </dw-tree-node>
  </ul>
</li>